module.exports = __webpack_public_path__ + "img/supermarché.4a83ec58.png";